<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-data-table fixed-header height="calc(100vh - 300px)"   :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:header="{ props }"><table-header-filter :headers="props.headers" :viewName="viewName" v-on:applyFilter="applyFilter"></table-header-filter></template>
                    <template v-slot:item="{ item }">
                        <tr :id="'r-' + item.ID">
                            <td>{{ item.AccountantDate | display_date('DD-MM-YYYY')}}</td>
                            <td class="text-end">{{ item.FirstCumulation | currency('¥', 2)}}</td>
                            <td class="text-end" v-if="adminRole || paymentRole">
                                <v-edit-dialog :return-value.sync="item.IncomeAmount" large lazy persistent @save="saveItem({'AccountantDate': item.ID, 'IncomeAmount': item.IncomeAmount})">
                                <div>{{ item.IncomeAmount | currency('¥',2)}}</div>
                                <template v-slot:input>
                                    <v-text-field v-model="item.IncomeAmount" type="number" step=".1" label="Thu" single-line autofocus></v-text-field>
                                </template>
                                </v-edit-dialog>
                            </td>
                            <td class="text-end" v-if="adminRole || paymentRole">
                                <v-edit-dialog :return-value.sync="item.Tuikuan" large lazy persistent @save="saveItem({'AccountantDate': item.ID, 'Tuikuan': item.Tuikuan})">
                                <div>{{ item.Tuikuan | currency('¥',2)}}</div>
                                <template v-slot:input>
                                    <v-text-field v-model="item.Tuikuan" type="number" step=".1" label="Tuikuan" single-line autofocus></v-text-field>
                                </template>
                                </v-edit-dialog>
                            </td>
                            <td class="text-end" v-if="adminRole || paymentRole">
                                <v-edit-dialog :return-value.sync="item.OutcomePurchase" large lazy persistent @save="saveItem({'AccountantDate': item.ID, 'OutcomePurchase': item.OutcomePurchase})">
                                <div>{{ item.OutcomePurchase | currency('¥',2)}}</div>
                                <template v-slot:input>
                                    <v-text-field v-model="item.OutcomePurchase" type="number" step=".1" label="Chi mua hàng" single-line autofocus></v-text-field>
                                </template>
                                </v-edit-dialog>
                            </td>
                            <td class="text-end" v-if="adminRole || paymentRole">
                                <v-edit-dialog :return-value.sync="item.OutcomeOther" large lazy persistent @save="saveItem({'AccountantDate': item.ID, 'OutcomeOther': item.OutcomeOther})">
                                <div>{{ item.OutcomeOther | currency('¥',2)}}</div>
                                <template v-slot:input>
                                    <v-text-field v-model="item.OutcomeOther" type="number" step=".1" label="Chi khác" single-line autofocus></v-text-field>
                                </template>
                                </v-edit-dialog>
                            </td>
                            <td class="text-end">{{ item.Cumulation | currency('¥', 2)}}</td>
                            <td>{{ item.Note }}</td>
                            <td class="text-center">
                                <v-icon v-if="adminRole || paymentRole" medium class="mr-2 mt-2" @click="gotoDetail(item.ID)">fa-edit</v-icon>
                                <v-icon v-if="adminRole" medium class="mr-2 mt-2" @click="deleteItem(item.ID)">fa-trash-alt</v-icon>
                            </td>
                        </tr>
                    </template>
                    <template v-slot:body.append>
                        <tr class="total-summary-td">
                            <td colspan="2" class="text-center font-weight-bold">Tổng</td>
                            <td class="text-end font-weight-bold">{{ summary.IncomeAmount | currency('', 2)}}</td>
                            <td class="text-end font-weight-bold">{{ summary.Tuikuan | currency('', 2)}}</td>
                            <td class="text-end font-weight-bold">{{ summary.OutcomePurchase | currency('', 2)}}</td>
                            <td class="text-end font-weight-bold">{{ summary.OutcomeOther | currency('', 2)}}</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";

export default {
    components: {
        "hpo-filter": Filtering
    },
    data() {
        let dataType = configs.DATA_TYPE;
        return {
            headers: [
                {
                    text: "Ngày",
                    value: "AccountantDate",
                    filterable: true,
                    dataType: dataType["Date"]
                },
                {
                    text: "Tồn đầu kỳ",
                    value: "FirstCumulation",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Thu",
                    value: "IncomeAmount",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Tuikuan",
                    value: "Tuikuan",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Chi mua hàng",
                    value: "OutcomePurchase",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Chi khác",
                    value: "OutcomeOther",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Tồn cuối kỳ",
                    value: "Cumulation",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Ghi chú",
                    value: "Note",
                    filterable: true,
                    quickSearch: true,
                    dataType: dataType["String"]
                },
                {
                    text: "Thao tác",
                    value: "",
                    align: "center"
                }
            ],
            pagination: {  ...configs.PAGINATION,  sortBy: ["ID"]  },
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            viewName: "accountantcumulation_list",
            filterConditions: [],
            quickFilterConditions: [],
            requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
    },
    computed: {
        ...mapState({
            items: state => state.accountant_cumulation.all.data,
            total_rows: state => state.accountant_cumulation.all.total,
            summary: state => state.accountant_cumulation.all.summary,
            loading: state => state.accountant_cumulation.loading
        }),
        tableConfig() {
            return {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        paymentRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
        },
    },
    methods: {
        filter_data: function () {
            this.$store.dispatch("accountant_cumulation/getList", this.tableConfig);
        },
        gotoDetail: function (id) {
            this.$router.push({
                name: "AccountantCumulationDetail",
                params: {
                    Pid: id,
                    title: `Chi tiết luồng thu/chi (#${id})`
                }
            });
        },
        deleteItem: function(id) {
            window.getApp.$emit('REQUEST_DELETE_DATA', id);
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        createData(username = '') {
            this.$router.push({
                name: "AccountantCumulationDetail",
                params: {
                Pid: 'tao-moi',
                title: `Tạo mới luồng thu/chi`
                }
            });
        },
        saveItem(obj) {
            var param = {
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("accountant_cumulation/setDetail", {param: this.tableConfig, data: obj, accountantDate: obj.AccountantDate});
        },
    },
    mounted() {
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_CREATE_DATA", this.createData);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("accountant_cumulation/removeDetail", id);
            setTimeout(this.filter_data, 200);
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA", this.createData);
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
    }
};
</script>
